<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="800">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-eye</v-icon> Visualizar FAQ
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-row class="justify-center mt-7">
              <v-col cols="12">
                <v-textarea
                  v-model="content.pergunta"
                  label="Pergunta"
                  rows="1"
                  auto-grow
                  readonly
                  dense
                  outlined
                ></v-textarea>
                <v-textarea
                  v-model="content.resposta"
                  label="Resposta"
                  dense
                  readonly
                  rows="3"
                  outlined
                ></v-textarea>
                <v-combobox
                  v-model="content.palavrasChave"
                  :items="[]"
                  chips
                  label="Palavras-Chave"
                  multiple
                  dense
                  readonly
                  persistent-hint
                  outlined
                >
                  <template v-slot:selection="{ attrs, item, select, selected }">
                    <v-chip
                      v-bind="attrs"
                      :input-value="selected"
                      close
                      small
                      @click="select"
                      @click:close="remover(item)"
                    >
                      <strong>{{ item }}</strong>&nbsp;
                    </v-chip>
                  </template>
                </v-combobox>
              </v-col>
            </v-row>
        </div>
        <div class="btn-group text-center">
          <v-btn color="primary" @click="$emit('onClose')">
            Fechar
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { Funcao } from '~/commons/classes/funcao';

export default {
  props: new DialogProps(Funcao),
}
</script>